/**
 * Last-ditch UI shown when the React tree fails to render (caught by
 * `<Sentry.ErrorBoundary>` in main.tsx). The error itself is already
 * captured by Sentry when configured, so the copy stays calm — no stack
 * trace, no scary numbers, just a reload affordance.
 *
 * Kept dependency-free of @studio/ui primitives so a bug in those
 * primitives can't crash the fallback itself. Inline styles for the
 * same reason — Tailwind's stylesheet is generally fine, but a CSS
 * load failure during boot would leave the user staring at unstyled
 * markup. The inline styles guarantee a readable fallback regardless.
 */
export function AppCrashFallback() {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 32,
        fontFamily: 'system-ui, sans-serif',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: 24, fontWeight: 600 }}>Studio hit a snag.</h1>
      <p style={{ color: '#64748b' }}>
        Refresh to try again. If this keeps happening, our team has been notified.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '8px 16px',
          borderRadius: 8,
          background: '#0f172a',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}
